export const ClaimsSegmentEvents = {
  FormStepNavigation: 'Claims Form - User changed the form step',
  FormFileUpload: 'Claims Form - User uploaded a file',
  FormFileDeleted: 'Claims Form - User deleted a file',
  FormDocumentSwitch: 'Claims Form - User toggled a document switch',
  FormSubmit: 'Claims Form - User submitted the form',
} as const;

export const ClaimsDashboardSegmentEvents = {
  DashboardOpened: 'Claims Dashboard - Dashboard opened',
  SearchBarChange: 'Claims Dashboard - Search Bar input changed',
  FilterDrawerOpened: 'Claims Dashboard - Filter drawer opened',
  FilterChanged: 'Claims Dashboard - Filter changed',
  SortChanged: 'Claims Dashboard - Sort changed',
  PageChanged: 'Claims Dashboard - Page changed',
  RowsPerPageChanged: 'Claims Dashboard - Rows per page changed',
  ExportRequested: 'Claims Dashboard - Export claims requested',
  ExportSuccess: 'Claims Dashboard - Claims successfully exported',
  ExportFailed: 'Claims Dashboard - Export claims failed',
  NoResultsShown: 'Claims Dashboard - No results shown',
  DashboardError: 'Claims Dashboard - Dashboard error',
  ClaimDetailsOpened: 'Claims Dashboard - Claim details opened',
  DetailsError: 'Claims Dashboard - Claim details error',
  BondDownloadSuccess: 'Claims Dashboard - Bond successfully downloaded',
  BondDownloadFailed: 'Claims Dashboard - Bond download failed',
  LedgerDownloadSuccess: 'Claims Dashboard - Ledger successfully downloaded',
  LedgerDownloadFailed: 'Claims Dashboard - Ledger download failed',
  DocumentDownloadSuccess: 'Claims Dashboard - Document successfully downloaded',
  DocumentDownloadFailed: 'Claims Dashboard - Document download failed',
  SubmitClaimClicked: 'Claims Dashboard - Submit claim clicked',
  ViewPreviousTrackerClicked: 'Claims Dashboard - View previous claim tracker clicked',
} as const;
